var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSound({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 31.9059C23 32.6419 22.616 33.2959 21.973 33.6529C21.329 34.0109 20.569 33.9929 19.943 33.6039L13 29.2899V18.3599L19.947 14.0609C20.573 13.6729 21.332 13.6569 21.974 14.0149C22.616 14.3729 23 15.0259 23 15.7609V31.9059ZM7 27.8389V19.8099C7 19.2559 7.563 18.8029 8.257 18.8029H11V28.8449H8.257C7.563 28.8449 7 28.3929 7 27.8389V27.8389ZM22.947 12.2679C21.663 11.5509 20.146 11.5859 18.895 12.3599L11.715 16.8029H8.257C6.461 16.8029 5 18.1519 5 19.8099V27.8389C5 29.4969 6.461 30.8449 8.257 30.8449H11.715L18.889 35.3029C19.543 35.7099 20.269 35.9139 20.997 35.9139C21.662 35.9139 22.329 35.7429 22.944 35.4009C24.231 34.6849 25 33.3789 25 31.9059V15.7609C25 14.2909 24.232 12.9839 22.947 12.2679V12.2679Z",
    fill: "#0F67BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.501 15.1695C30.021 14.8905 29.411 15.0565 29.135 15.5335C28.857 16.0125 29.022 16.6235 29.499 16.8995C31.967 18.3285 33.5 20.9845 33.5 23.8315C33.5 26.6785 31.967 29.3335 29.499 30.7625C29.022 31.0385 28.857 31.6495 29.135 32.1285C29.32 32.4485 29.655 32.6275 30.001 32.6275C30.171 32.6275 30.343 32.5845 30.501 32.4925C33.584 30.7085 35.5 27.3895 35.5 23.8315C35.5 20.2735 33.584 16.9535 30.501 15.1695",
    fill: "#0F67BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0459 9.16166C34.5869 8.86166 33.9649 8.99066 33.6619 9.45366C33.3599 9.91566 33.4909 10.5357 33.9539 10.8377C38.3659 13.7147 40.9999 18.5727 40.9999 23.8317C40.9999 29.1107 38.3509 33.9787 33.9109 36.8517C33.4479 37.1527 33.3159 37.7717 33.6149 38.2357C33.8069 38.5307 34.1279 38.6917 34.4559 38.6917C34.6429 38.6917 34.8309 38.6407 34.9989 38.5317C40.0089 35.2877 42.9999 29.7927 42.9999 23.8317C42.9999 17.8937 40.0259 12.4097 35.0459 9.16166",
    fill: "#0F67BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSound);
export default __webpack_public_path__ + "static/media/Sound.a359db11efd47674a57446b0a3be9390.svg";
export { ForwardRef as ReactComponent };